<template>
  <footer id="digibook-footer" class="digibook-footer">
   <div class="holder container">
      <div class="copyright" v-html="$t('front_end.common.copyright')"></div>
      <div class="logo"><img src="../../assets/images/logo-footer.png" alt="logo"></div>
   </div>
</footer>
</template>

<script>
export default {};
</script>

<style scoped src="../../assets/css/common/footer.css"></style>
